module.exports = __webpack_public_path__ + "static/media/reubication-icon.ea4ed65d.svg";